import {useClient, useDictionary} from '@adamlip/okeoke.client'
import GroupMember from './GroupMember'
import {useEffect, useState} from 'react'
import {ScrollShadow} from '@heroui/react'

export default function SizeGroup({group, setDisableNext, setSizeGroupsValidation, getSelectedMembers, addSelectedItem, activeGroup}) {
	const {getName} = useClient()
	const {getValue} = useDictionary()

	const [selectedGroupMembers, setSelectedGroupMembers] = useState({})
	const [groupValid, setGroupValid] = useState(null)

	const onAddMember = (member) => {
		addSelectedItem(member)
		validateGroup()
	}

	const validateGroup = () => {
		let selectedMembers = getSelectedMembers(group.uuid)
		setSelectedGroupMembers(selectedMembers)

		if (typeof selectedMembers === 'object') {
			let totalCount = Object.values(selectedMembers).reduce((acc, curr) => acc + (curr?.count || 0), 0)
			let valid = true
			if (group?.maxSelect > 0 && totalCount > group.maxSelect) valid = false

			if (totalCount < group.minSelect) valid = false
			setSizeGroupsValidation(group.uuid, valid)
			setGroupValid(valid)
			setDisableNext(!valid)
		} else {
		}
	}

	useEffect(() => {
		if (group?.minSelect > 0) setSizeGroupsValidation(group?.uuid, false)
		validateGroup()
		//eslint-disable-next-line
	}, [group, activeGroup])

	return (
		<div className='grow overflow-hidden px-2 pt-6 flex flex-col gap-0'>
			<div className={`${groupValid === true ? 'text-green-600' : groupValid === false ? 'text-red-600' : ''}`}>
				<div className='text-lg'>{getName(group?.name)}</div>
				{getName(group?.description).length > 0 && <div className='text-sm'>{getName(group?.description)}</div>}
				<div className='flex flex-wrap gap-2 text-sm'>
					{+group?.minSelect > 0 && (
						<span>
							{getValue('app_v2_menu_group_min_select')}: {group?.minSelect}
						</span>
					)}
					{+group?.maxSelect > 0 && (
						<span>
							{getValue('app_v2_menu_group_max_select')}: {group?.maxSelect}
						</span>
					)}
				</div>
			</div>
			<ScrollShadow className='mt-2 flex flex-wrap gap-4 pt-2 grow overflow-y-scroll overflow-x-hidden'>
				{group?.members?.length < 1 && getValue('app_v2_menu_no_available_group_members')}
				{group?.members?.map((member) => (
					<GroupMember key={member.uuid} group={group} member={member} sizeGroupUUID={group.uuid} addMember={onAddMember} selectedCount={selectedGroupMembers?.[member.uuid]?.count} />
				))}
			</ScrollShadow>
		</div>
	)
}
